import comboChartAdapter from "./adapters/combo";
import heatmapChartAdapter from "./adapters/heatmap";
import pieChartAdapter from "./adapters/pie";
import scatterChartAdapter from "./adapters/scatter";
import geoHeatmapAdapter from "./adapters/geoHeatmap";
import radarChartAdapter from "./adapters/radar";
import gaugeChartAdapter from "./adapters/gauge";
import { createCategoryChartAdapter } from "./adapters/category";
import { isChartTypeRegistered, registerChartAdapter } from "./registry";
function ensureAdapterRegistration() {
    if (!isChartTypeRegistered("bar")) {
        registerChartAdapter(createCategoryChartAdapter("bar"));
    }
    if (!isChartTypeRegistered("line")) {
        registerChartAdapter(createCategoryChartAdapter("line"));
    }
    if (!isChartTypeRegistered("pie")) {
        registerChartAdapter(pieChartAdapter);
    }
    if (!isChartTypeRegistered("combo")) {
        registerChartAdapter(comboChartAdapter);
    }
    if (!isChartTypeRegistered("scatter")) {
        registerChartAdapter(scatterChartAdapter);
    }
    if (!isChartTypeRegistered("heatmap")) {
        registerChartAdapter(heatmapChartAdapter);
    }
    if (!isChartTypeRegistered("geoHeatmap")) {
        registerChartAdapter(geoHeatmapAdapter);
    }
    if (!isChartTypeRegistered("radar")) {
        registerChartAdapter(radarChartAdapter);
    }
    if (!isChartTypeRegistered("gauge")) {
        registerChartAdapter(gaugeChartAdapter);
    }
}
ensureAdapterRegistration();
